import { CabinetNavItem } from './cabinet.schemas';

export const cabinetNav: CabinetNavItem[] = [
  { id: 'dashboard', label: 'Главная' },
  { id: 'shop', label: 'Магазин' },
  { id: 'devices', label: 'Устройства' },
  { id: 'wallet', label: 'Баланс' },
  { id: 'account', label: 'ЛК' },
  { id: 'import', label: 'Подключение' },
];

export const serverTiles = [
  { icon: '🇫🇮', code: 'FN', title: 'Финляндия', available: true },
  { icon: '🇳🇱', code: 'NL', title: 'Нидерланды', available: true },
  { icon: '🤖', code: 'AI', title: 'ChatGPT', available: true },
  { icon: '🎬', code: 'YT', title: 'YouTube', available: true },
  { icon: '📞', code: 'WA', title: 'WhatsApp', available: true },
  { icon: '🔵', code: 'DS', title: 'Discord', available: true },
  { icon: '🎵', code: 'TT', title: 'TikTok', available: true },
  { icon: '📄', code: 'WL', title: 'Белый Лист', available: false },
];
